const lettersOrNumbers = /^[0-9a-zA-Z]+$/;
const allowedCharacters = /^[0-9a-zA-Z-_/.]+$/;

const isBranchNameValid = (value: string) => {
    if (value.length < 2 || value.length > 100) {
        return false;
    }

    // Allowed chars in general
    if (!value.match(allowedCharacters)) {
        return false;
    }

    // Name can only start with letter, digit, or dot
    if (!value[0].match(lettersOrNumbers) && value[0] !== '.') {
        return false;
    }

    // Should end with letter or digit
    if (!value[value.length - 1].match(lettersOrNumbers)) {
        return false;
    }

    // Two consecutive dots
    if (value.includes('..')) {
        return false;
    }

    // Two consecutive slashes
    if (value.includes('//')) {
        return false;
    }

    // Slash-separated segment starting with a dot or ending with ".lock"
    if (
        value.includes('/') &&
        (value.match(/^\./) || value.includes('/.') || value.includes('.lock/') || value.match(/.lock$/))
    ) {
        return false;
    }

    return true;
};

export default isBranchNameValid;
